export default __webpack_public_path__ + "5006917e66e0307714d8740b80f5e8a0.png";